import { UpdateMobileAppsSubmissionStatus } from '@flipdish/api-client-typescript';
import { useMutation } from 'react-query';

import { mobileAppsService } from '../components/SalesChannels/MobileApps/mobileApps.services';

export const useMutationUpdateMobileAppSubmissionStatusHook = (
  appId: string,
  submissionId: number,
  onSuccess: () => void,
  onError: () => void
) => {
  return useMutation(
    (updatedStatus: Partial<UpdateMobileAppsSubmissionStatus>) => {
      return mobileAppsService.updateMobileAppSubmissionStatus(appId, submissionId, updatedStatus);
    },
    {
      onSuccess: () => {
        onSuccess();
      },
      onError: () => {
        onError();
      },
    }
  );
};
